<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          @click="handleStep('PEDIDOS')"
          :class="['nav-link link-nav-resident', step == 'PEDIDOS' && 'active']"
          id="nav-pedidos"
          data-toggle="tab"
          href="#pedidos"
          role="tab"
          aria-controls="pedidos"
          aria-selected="true"
          >PEDIDOS DIVERSOS</a
        >
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="step == 'PEDIDOS'"
        :class="['tab-pane fade', step == 'PEDIDOS' && 'show active']"
        id="pedidos"
        role="tabpanel"
        aria-labelledby="nav-pedidos"
      >
        <order :resident="resident" />
      </div>
    </div>
  </div>
</template>

<script>
import Order from "./order/order";

import routes from "../../routes";

export default {
  name: "MenuOrder",

  components: {
    Order,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      step: "PEDIDOS",

      resident_id: "",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    handleStep(step) {
      let newNav;

      if (step == "PEDIDOS") {
        newNav = "order";
      }

      let { tab, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, nav: newNav } });
      }

      this.step = step;
    },

    async retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      const { nav } = routes.history.current.query;

      if (nav) {
        if (nav == "order") {
          this.step = "EVOLUCAO";
        }
      }
    },
  },
};
</script>
